import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { GalleryTitle, ImageGallery } from "../../../Constant";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { MyGallery } from "./MyGallery";

const GalleryGridContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={GalleryTitle} parent={GalleryTitle} title={GalleryTitle} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={ImageGallery} />
              <CardBody className="gallery my-gallery">
                <Row>
                  <MyGallery />
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default GalleryGridContainer;
